export enum OpportunityOfferMailActionType {
    OFFER_SENT = '3b32d9b6-e8af-4c67-b301-0aa985302f37',
    ACCEPTED = '37b66d6a-a73e-426e-8f07-3add984bc0bb',
    REQUESTED_REVISION = 'ac9c4da9-2608-4972-a1d5-913451edd77a',
    REJECTED = '2c5a712a-ab96-4fe8-98c1-7151ca26c0cc'
}
